import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const IngresoReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Actualizar form de cierre de cuentas
   */
  builder
    .addCase(Types.FORM_CIERRE_CUENTAS_LOADING, (state) => {
      state.formCierreCuentasLoading = true;
    })
    .addCase(Types.FORM_CIERRE_CUENTAS_SUCCESS, (state, action) => {
      const { formCierreCuentasData } = action;
      state.formCierreCuentasData = formCierreCuentasData;
      state.formCierreCuentasLoading = false;
      state.consultarIngresoLoading = false;
      state.getProcedimientosPermitidosCierreCuentasLoading = false;
      state.validarProcedimientoCierreCuentasLoading = false;
      state.eliminarProcedimientoCierreCuentasLoading = false;
      state.consultarReclamantesLoading = false;
      state.cerrarCuentaClinicaLoading = false;
      state.consultarDetalleCierreCuentaLoading = false;
      state.calcularOxigenoLoading = false;
    });

  /**
   * Consultar un ingreso
   */
  builder.addCase(Types.CONSULTAR_INGRESO_LOADING, (state) => {
    state.consultarIngresoLoading = true;
  });

  /**
   * Consultar detalle de un cierre de cuenta
   */
  builder.addCase(Types.CONSULTAR_DETALLE_CIERRE_CUENTA_LOADING, (state) => {
    state.consultarDetalleCierreCuentaLoading = true;
  });

  /**
   * Consultar procedimientos permitidos para cierre de cuentas
   */
  builder.addCase(
    Types.GET_PROCEDIMIENTOS_PERMITIDOS_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.getProcedimientosPermitidosCierreCuentasLoading = true;
    }
  );

  /**
   * Agregar procedimiento cierre de cuentas
   */
  builder.addCase(
    Types.VALIDAR_PROCEDIMIENTO_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.validarProcedimientoCierreCuentasLoading = true;
    }
  );

  /**
   * Eliminar procedimiento cierre de cuentas
   */
  builder.addCase(
    Types.ELIMINAR_PROCEDIMIENTO_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.eliminarProcedimientoCierreCuentasLoading = true;
    }
  );

  /**
   * Consultar un reclamantes
   */
  builder.addCase(Types.CONSULTAR_RECLAMANTES_LOADING, (state) => {
    state.consultarReclamantesLoading = true;
  });

  /**
   *  Cerrar cuenta clinica
   */
  builder.addCase(Types.CERRAR_CUENTA_CLINICA_LOADING, (state) => {
    state.cerrarCuentaClinicaLoading = true;
  });

  /**
   *  Consultar cierres cuentas
   */
  builder.addCase(Types.CONSULTAR_CIERRES_CUENTAS_LOADING, (state) => {
    state.consultarCierresCuentasLoading = true;
  });

  /**
   * Agregar procedimiento cierre de cuentas
   */
  builder.addCase(
    Types.CALCULAR_OXIGENO_LOADING,
    (state) => {
      state.calcularOxigenoLoading = true;
    }
  );

  /**
   * Actualizar form de consulta de cierres de cuentas
   */
  builder
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_LOADING, (state) => {
      state.formConsultaCierresCuentasLoading = true;
    })
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_SUCCESS, (state, action) => {
      const { formConsultaCierresCuentasData } = action;
      state.formConsultaCierresCuentasData = formConsultaCierresCuentasData;
      state.formConsultaCierresCuentasLoading = false;
      state.consultarCierresCuentasLoading = false;
    })
    .addCase(Types.CONSULTAR_PACIENTES_INGRESADOS_LOADING, (state) => {
      state.consultarPacientesIngresadosLoading = true;
    })
    .addCase(Types.FORM_PACIENTES_INGRESADOS_SUCCESS, (state, action) => {
      const { formPacientesIngresadosData } = action;
      state.formPacientesIngresadosData = formPacientesIngresadosData;
      state.consultarPacientesIngresadosLoading = false;
    })
    .addCase(Types.FORM_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { formHojaQuirurgicaData } = action;
      state.formHojaQuirurgicaData = formHojaQuirurgicaData;
    })
    .addCase(Types.OBTENER_CAMPOS_HOJA_QUIRURGICA_LOADING, (state) => {
      state.obtenerCamposHojaQuirurgicaLoading = true;
      state.obtenerCamposHojaQuirurgicaError = null;
    })
    .addCase(Types.OBTENER_CAMPOS_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { camposHojaQuirurgicaData } = action;
      state.camposHojaQuirurgicaData = camposHojaQuirurgicaData;
      state.obtenerCamposHojaQuirurgicaLoading = false;
      state.obtenerCamposHojaQuirurgicaError = null;
    })
    .addCase(Types.OBTENER_CAMPOS_HOJA_QUIRURGICA_FAILURE, (state, action) => {
      const { camposHojaQuirurgicaError } = action;
      state.camposHojaQuirurgicaData = null;
      state.obtenerCamposHojaQuirurgicaLoading = false;
      state.obtenerCamposHojaQuirurgicaError = camposHojaQuirurgicaError;
    })
    .addCase(Types.CREAR_SOLICITUD_HOJA_QUIRURGICA_LOADING, (state) => {
      state.crearSolicitudHojaQuirurgicaLoading = true;
      state.crearSolicitudHojaQuirurgicaError = null;
      state.crearSolicitudHojaQuirurgicaData = null;
    })
    .addCase(Types.CREAR_SOLICITUD_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { crearSolicitudHojaQuirurgicaData } = action;
      state.crearSolicitudHojaQuirurgicaData = crearSolicitudHojaQuirurgicaData;
      state.crearSolicitudHojaQuirurgicaLoading = false;
      state.crearSolicitudHojaQuirurgicaError = null;
    })
    .addCase(Types.CREAR_SOLICITUD_HOJA_QUIRURGICA_FAILURE, (state, action) => {
      const { crearSolicitudHojaQuirurgicaError } = action;
      state.crearSolicitudHojaQuirurgicaData = null;
      state.crearSolicitudHojaQuirurgicaLoading = false;
      state.crearSolicitudHojaQuirurgicaError = crearSolicitudHojaQuirurgicaError;
    })
    .addCase(Types.BUSCAR_SOLICITUDES_HOJA_QUIRURGICA_LOADING, (state) => {
      state.buscarSolicitudesHojaQuirurgicaLoading = true;
    })
    .addCase(Types.FORM_SOLICITUDES_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { formSolicitudesHojaQuirurgicaData } = action;
      state.formSolicitudesHojaQuirurgicaData = formSolicitudesHojaQuirurgicaData;
      state.buscarSolicitudesHojaQuirurgicaLoading = false;
    })
    .addCase(Types.OBTENER_DETALLE_SOLICITUD_HOJA_QUIRURGICA_LOADING, (state) => {
      state.obtenerDetalleSolicitudHojaQuirurgicaLoading = true;
      state.obtenerDetalleSolicitudHojaQuirurgicaError = null;
      state.detalleSolicitudHojaQuirurgicaData = null;
    })
    .addCase(Types.OBTENER_DETALLE_SOLICITUD_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { detalleSolicitudHojaQuirurgicaData } = action;
      state.detalleSolicitudHojaQuirurgicaData = detalleSolicitudHojaQuirurgicaData;
      state.obtenerDetalleSolicitudHojaQuirurgicaLoading = false;
      state.obtenerDetalleSolicitudHojaQuirurgicaError = null;
    })
    .addCase(Types.OBTENER_DETALLE_SOLICITUD_HOJA_QUIRURGICA_FAILURE, (state, action) => {
      const { detalleSolicitudHojaQuirurgicaError } = action;
      state.obtenerDetalleSolicitudHojaQuirurgicaError = detalleSolicitudHojaQuirurgicaError;
      state.obtenerDetalleSolicitudHojaQuirurgicaLoading = false;
      state.detalleSolicitudHojaQuirurgicaData = null;
    })
    .addCase(Types.LIMPIAR_DETALLE_SOLICITUD_HOJA_QUIRURGICA, (state) => {
      state.detalleSolicitudHojaQuirurgicaData = null;
      state.obtenerDetalleSolicitudHojaQuirurgicaLoading = false;
      state.obtenerDetalleSolicitudHojaQuirurgicaError = null;
    })
    .addCase(Types.LIMPIAR_FORM_HOJA_QUIRURGICA, (state) => {
      state.formHojaQuirurgicaData = INITIAL_STATE.formHojaQuirurgicaData;
    });
});
